import { useApiBreedList } from '@rover/rsdk/src/apiClient/latest/api-breed-list';
import type { Breed } from '@rover/rsdk/src/apiClient/latest/model/breed';
import { ErrorType } from '@rover/rsdk/src/modules/Network/orvalHTTPInterface';
import { PetType } from '@rover/types/src/Pet';

export const useBreeds = (
  petType?: PetType
): {
  breeds: Breed[];
  isLoading: boolean;
  error: ErrorType<Error> | null;
} => {
  const params = petType === PetType.CAT ? { petType: 'cat' } : {};
  const query = useApiBreedList(params, { query: { staleTime: Infinity } });
  return { breeds: query.data?.results ?? [], error: query.error, isLoading: query.isLoading };
};
